import { Doughnut, Pie , Bar} from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend ,
  CategoryScale,
  LinearScale,
  BarElement,
  Title} from 'chart.js';
import "./stackBarChart.scss";


ChartJS.register(  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,ArcElement);

function PieChart({ stackBarData, showTitle }) {
    return (
        <div >
            <Doughnut style={{height: '250px'}}
                data={stackBarData}
                options={{
                    plugins: {
                        title: {
                            display: true,
                            text: showTitle
                        },
                        legend: {
                            display: true,
                            position: 'bottom'
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false
                }}
            />
        </div>
    );
}
 

export default PieChart;